import React, { Suspense } from 'react';
import { __ } from 'i18n/index';
import { LadderPopup } from './LadderPopup';
import HistoryPopupSkeleton from 'react/matchHistoryPopup/HistoryPopupSkeleton';
import AnimatedHeight from 'react/elements/AnimatedHeight';

const MatchHistoryPopup = React.lazy(() => import(/* webpackChunkName: "MatchHistoryPopup" */ 'react/matchHistoryPopup/MatchHistoryPopup'));

export class MatchHistory {

	// data.againstPlayer opens the viewer's (data.player's) head-to-head with them.
	static retrieveHistory(data) {
		const { player, againstPlayer = null } = data;
		// The popup sets its title as HTML, so the username goes in as text afterwards.
		const popup = LadderPopup.create('', __('Match history'), {
			buttons: true
		});
		popup.changeTitleText(againstPlayer ? __('Head-to-head') : __('%s\'s recent sets', player.username));
		popup.popup.find('.modal-dialog').addClass('history-popup__dialog');
		popup.onDismiss.then(() => popup.popup.find('.modal-dialog').removeClass('history-popup__dialog'));
		popup.onOpen.then(() => {
			popup.updateContent(
				<AnimatedHeight>
					<Suspense fallback={<HistoryPopupSkeleton />}>
						<MatchHistoryPopup player={player} againstPlayer={againstPlayer} onNavigate={() => popup.dismiss()} />
					</Suspense>
				</AnimatedHeight>
			);
		});
	}
}
